__turbopack_context__.v({
  "className": "geist_e7e502e-module__k-_07G__className",
  "variable": "geist_e7e502e-module__k-_07G__variable",
});
